import React, {useState, useEffect, Fragment, useRef} from 'react';
import './comentario.css';
import { useForm } from '../../../hooks/useForm';
import { useAxiosPost } from '../../../hooks/useAxiosPost';
import { IoClose } from "react-icons/io5";
import { useTranslation } from 'react-i18next';

const Comenta = ({popup, setPopup}) => {
    const [count, setCount] = useState(0);
    const [t2] = useTranslation("detail_blog");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [formSubmitted, setFormSubmitted] = useState( false )
    const { onInputChange, fromName, correo, ciudad, body, onResetForm} = useForm({
        fromName: '',
        correo: '',
        ciudad: '',
        body: '',
    });
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const notAllowedChars = ['"', '`', '=', ';', '[', ']', '{', '}', '/', '\\', '&', '<', '>',':','\''];

    const [t, i18n] = useTranslation("global");

    const handleInputChangeValidated = (event) => {
        onInputChange(event);
        const value = event.target.value;
 
        // Verificar si el valor contiene algún carácter no permitido
        const containsNotAllowedChars = notAllowedChars.some(char => value.includes(char));
        let cleanBody = '';
 
        if (containsNotAllowedChars) {
            event.target.classList.add("invalid");
            for (let character of body) {
                cleanBody += notAllowedChars.includes(character) ? '' : character;
            }
            onInputChange({ target: { name: 'body', value: cleanBody }});
        } else {
            event.target.classList.remove("invalid");
        }
 
        setCount(event.target.value.length);
    }


    const handleFormSubmitted = (value) => {
        setFormSubmitted(value);
    };

    const { data, isLoading, error} = useAxiosPost(  
        formSubmitted ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-comment' : null, 
        { fromName: " ", from:' ', to:' ', subject:'Contacto Ricardo Salinas', body:"Nuevo comentario al contacto del Home\n\n\n" +fromName +"\n" + correo +"\n" + ciudad + '\n\nComentario: \n' + body, isBodyHtml: false},
        handleFormSubmitted);

    const onFormSubmit = ( event ) => {
        event.preventDefault();


        if(fromName.length <= 1)
        {
            alert((t2('comments.v_nombre')));
            return;
        }
            
        if(correo.length <= 1)
        {
            alert((t2('comments.v_email')));
            return;
        }
        
        if(body.length <= 1)
        {
            alert((t2('comments.v_comentario')));
            return;
        }
        
        if (emailRegex.test(correo)) {
            console.log('Correo electrónico válido:', correo);
          } else {
            alert((t2('comments.v_valido')));
            return;
          }

        let cleanBody = '';

        for (let character of body) {
        cleanBody += notAllowedChars.includes(character) ? '' : character;
        }

        onInputChange({ target: { name: 'body', value: cleanBody }});
                
        setFormSubmitted(true);
        

    }

    useEffect(() => {

        if(data === undefined) {
            onResetForm();
        }
    }, [data]);

    return (
        <Fragment>
            <form onSubmit={onFormSubmit}>
                <div class="contenedor_Comentario">
                    <div class="formContainer">
                        <div className='closeContainer'>
                            <IoClose size={30} onClick={() => {
                                setPopup(false);
                            }}/>
                        </div>
                        <div class="preg">
                            <div class="mb-3">
                                <input id="name" class="input-form input-value input_dat" placeholder={(t('forms.name'))} name="fromName" value={fromName} onChange={onInputChange} />
                            </div>
                            <div class="separatorContainer">
                                <div className='separator'/>
                            </div>
                            <div class="mb-3">
                                <input id="email" class="input-form input-value input_dat" placeholder={(t('forms.email'))} name="correo"  value={correo} onChange={onInputChange}  />
                            </div>
                            <div class="separatorContainer">
                                <div className='separator'/>
                            </div>
                            <div class="mb-3">
                                <input id="ciudad" class="input-form input-value input_dat" placeholder={(t('forms.city'))} type="text" name="ciudad"  value={ciudad} onChange={onInputChange} />
                            </div>
                            <div class="separatorContainer">
                                <div className='separator'/>
                            </div>
                            <div className="commentsContainer">
                                <div className="commentsTitleContainer">
                                    <p>{(t('forms.comment'))}</p>
                                    <p>{count}/560</p>
                                </div>
                                <textarea
                                    type="text"
                                    class="form inputTextArea"
                                    name="body"
                                    id="numLetras"
                                    maxLength={560} 
                                    value={body}
                                    onChange={handleInputChangeValidated}
                                    placeholder={(t('forms.write'))}
                                />
                            </div>
                            <div class="separatorContainer">
                                <div className='separator'/>
                            </div>
                        </div>
                    </div>
                    
                    <div class="div_bot3_LB sendButtonContainer">
                        {
                            isLoading ?
                            (<span>{(t('forms.sending'))}</span>) :
                            (<button class="buton3_LB" type='submit'>{(t('forms.send'))}</button>)
                        }
                    </div>
                </div>
            </form>
        </Fragment>
    )
}

export default Comenta